import WeightMetricFieldGroup from './WeightMetricFieldGroup';

export default WeightMetricFieldGroup;
